module.exports = __webpack_public_path__ + "static/media/daniel-projekt-lead.01186588.png";